import React from "react";
import { useStateContext } from "../contexts/ContextProvider";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import ThemeSettings from "./ThemeSettings";
import Footer from "./Footer";

const Layout = ({ children, notificationTrigger }) => {
  const { activeMenu, themeSettings } = useStateContext();

  const sidebarWidth = activeMenu ? "240px" : "0px";

  return (
    <div className="h-screen w-full overflow-hidden bg-main-bg dark:bg-main-dark-bg">
      <div className="flex h-full w-full overflow-hidden">
        <aside
          className="shrink-0 transition-all duration-300 ease-in-out overflow-hidden border-r border-gray-200 dark:border-gray-700"
          style={{ width: sidebarWidth }}
        >
          <div className="h-full w-[240px]">
            <Sidebar />
          </div>
        </aside>

        <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <header className="sticky top-0 z-10 shrink-0 bg-main-bg dark:bg-main-dark-bg">
            <Navbar notificationTrigger={notificationTrigger} />
          </header>

          <section className="flex-1 min-w-0 overflow-auto custom-scrollbar">
            {themeSettings && <ThemeSettings />}
            <div className="min-w-0 p-4">{children}</div>
          </section>

          <div className="shrink-0">
            <Footer />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;